import { API_BASE_URL, API_PATHS,  } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class IntrestandShortlistedService {


    static sendInterest(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.sendInterest}`;
        return axiosInstance
            .post(api, data)

    }

      static getReceivedInterests(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.getReceivedInterests}`;
        return axiosInstance
            .get(api, data)

    }

      static getSentInterests(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.getSentInterests}`;
        return axiosInstance
            .get(api, data)

    }
      static getShortlistData(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.getShortlistData}`;
        return axiosInstance
            .get(api, data)

    }

    


      static respondToInterest(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.respondToInterest}`;
        return axiosInstance
            .post(api, data)

    }

       static shortlistUser(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.shortlistUser}`;
        return axiosInstance
            .post(api, data)

    }

  
}

export default IntrestandShortlistedService;
